/* eslint-disable @typescript-eslint/camelcase */
export const breakpoints = {
  lg: 1024,
  lg_bg: 1200,
  md: 769,
  md_pr: 993,
  // eslint-disable-next-line @typescript-eslint/camelcase
  md_sm: 650,
  sm_md: 510,
  sm: 480,
  xl: 1440,
  xxl: 1440,
  semiXl: 1300,
  xs: 321,
  xxs: 0,
};
